import React from 'react'
import { formatDate } from '../../utils/datetime';

function LastUpdatedAt(date) {
  return (
    date.updatedAt
      ? (
        <div className="weight-400 fs-12x mt-2 italic-style text-muted">
          <em>Last Updated at: {formatDate(date.updatedAt)}</em>
        </div>
        ) 
      : null
  )
}
export default LastUpdatedAt;  